module.exports = __webpack_public_path__ + "static/media/union.80958672.webp";